import apiSlice from "./ApiSlice";

const TransactionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllTransaction: builder.query({
      providesTags: ["transaction"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/transaction/admin-filter",
          method: "POST",
          body,
        };
      },
    }),
    getAllTransactionForExcel: builder.mutation({
      // providesTags: ["transaction"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/transaction",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllTransactionQuery,
  useGetAllTransactionForExcelMutation
} = TransactionApi;
